import { render } from "./UploadIcon.vue?vue&type=template&id=167707c8&scoped=true"
import script from "./UploadIcon.vue?vue&type=script&lang=js"
export * from "./UploadIcon.vue?vue&type=script&lang=js"

import "./UploadIcon.vue?vue&type=style&index=0&id=167707c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167707c8"]])

export default __exports__